import { render } from "./app.vue?vue&type=template&id=2836ff77"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2836ff77"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2836ff77', __exports__)) {
    console.log('reload')
    api.reload('2836ff77', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=2836ff77", () => {
    console.log('re-render')
    api.rerender('2836ff77', render)
  })

}


export default __exports__